var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 276,
    viewBox: "0 0 252 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.83 18.195a17.15 17.15 0 0 1 16.885-1.24l96.666 45.968c5.442 2.588 9.064 7.843 9.502 13.787l7.767 105.561c.437 5.943-2.378 11.672-7.383 15.027l-88.899 59.593a17.15 17.15 0 0 1-16.884 1.24l-96.666-45.968c-5.443-2.588-9.065-7.843-9.502-13.787l-7.767-105.56c-.438-5.944 2.377-11.673 7.382-15.028l88.899-59.593z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.822 11.614a18.299 18.299 0 0 1 17.923-1.316l102.59 48.46c5.776 2.729 9.619 8.273 10.081 14.544l.687 9.342-6.746.496 1.488 20.225 6.746-.495 6.02 81.817c.462 6.272-2.529 12.318-7.843 15.861l-94.395 62.924a18.3 18.3 0 0 1-17.924 1.316L23.86 216.328c-5.776-2.728-9.619-8.272-10.08-14.544l-.688-9.342 6.75-.496-1.489-20.226-6.749.496-6.02-81.817c-.46-6.272 2.529-12.317 7.844-15.86l94.394-62.925zm1.008 6.58a17.148 17.148 0 0 1 16.884-1.24l96.666 45.968c5.443 2.588 9.065 7.844 9.502 13.788l7.767 105.561c.437 5.943-2.377 11.672-7.382 15.027l-88.899 59.593a17.151 17.151 0 0 1-16.885 1.24l-96.665-45.968c-5.443-2.588-9.065-7.843-9.502-13.787L12.549 92.815c-.437-5.944 2.377-11.672 7.382-15.027l88.899-59.594z",
    fill: "url(#c75j0po7da)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m199.634 76.262-72.202-35.638a16.612 16.612 0 0 0-16.84 1.237l-66.21 45.801c-4.985 3.448-7.778 9.35-7.326 15.481l5.992 81.439c.45 6.131 4.077 11.561 9.513 14.244l72.202 35.637a16.653 16.653 0 0 0 5.19 1.581l-7.974-108.365 2.941-6.147 80.129-40.623c-.099-1.348-3.651-3.66-5.415-4.647z",
    fill: "url(#6cof6r8hwb)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m121.551 121.777 3.436.595 3.313-1.09 8.556 116.298-6.748.495-8.557-116.298z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m124.927 121.532-86.963-29.2-4.69 5.428 92.211 31.357 85.067-42.68-3.87-6.494-81.755 41.589z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.884 33.843a16.68 16.68 0 0 0-16.743 1.23L37.343 84.893c-4.958 3.394-7.74 9.197-7.296 15.223l6.51 88.474c.443 6.027 4.043 11.361 9.445 13.993l79.308 38.654a16.677 16.677 0 0 0 16.742-1.23l72.798-49.822c4.958-3.393 7.74-9.196 7.296-15.222l-.464-6.312-6.747.495.205 2.794a17.445 17.445 0 0 1-2.296 10.025 17.011 17.011 0 0 1-5.032 5.458l-66.21 45.801a16.612 16.612 0 0 1-16.84 1.236L52.56 198.824c-5.436-2.684-9.062-8.114-9.513-14.245l-5.992-81.438a17.441 17.441 0 0 1 1.866-9.237 17.02 17.02 0 0 1 5.461-6.246l66.21-45.801a16.613 16.613 0 0 1 16.841-1.237l72.202 35.638c5.436 2.683 9.062 8.113 9.513 14.245l4.299 58.419 6.747-.496-4.557-61.937c-.444-6.026-4.045-11.36-9.447-13.993l-79.306-38.653z",
    fill: "url(#s39qy7oinc)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m140.799 198.898-2.232-30.339 28.559-14.539 15.223 10.161-12.991 20.178-28.559 14.539z",
    fill: "url(#i7nt2z6apd)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m138.072 161.819-2.232-30.339 28.559-14.538 15.223 10.161-12.991 20.177-28.559 14.539z",
    fill: "url(#0mjc70o16e)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c75j0po7da",
    x1: 273.897,
    y1: 219.034,
    x2: 77.348,
    y2: -15.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A44E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6cof6r8hwb",
    x1: 66.732,
    y1: 247.118,
    x2: 178.104,
    y2: 119.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1921AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A60F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s39qy7oinc",
    x1: 244.042,
    y1: 204.323,
    x2: 82.615,
    y2: 16.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A44E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i7nt2z6apd",
    x1: 188.854,
    y1: 189.192,
    x2: 157.428,
    y2: 146.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A44E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0mjc70o16e",
    x1: 186.127,
    y1: 152.113,
    x2: 154.702,
    y2: 109.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A44E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.c02bb68a5da3bb185aa67d409aedccac.svg";
export { ForwardRef as ReactComponent };